module.exports = __webpack_public_path__ + "img/QR-bg.b2defe5d.png";